import servicesUtils from "../../../utils/servicesUtils";

const updateWorkspaceReferral = async (
  workspaceId: number,
  params: { referral_id: number; status: number }
) => {
  const response = await servicesUtils.postService(
    `/workspace_referral/${workspaceId}/update/`,
    params
  );
  return response;
};

export default updateWorkspaceReferral;
